import { render, staticRenderFns } from "./ppbatchoverview.vue?vue&type=template&id=75673b49&scoped=true&"
import script from "./ppbatchoverview.vue?vue&type=script&lang=js&"
export * from "./ppbatchoverview.vue?vue&type=script&lang=js&"
import style0 from "./ppbatchoverview.vue?vue&type=style&index=0&id=75673b49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75673b49",
  null
  
)

export default component.exports